// Graphcool API
export const PROJECT_ID = "cmms-prod";
export const GRAPHCOOL_API = `https://api.graph.cool/simple/v1/${PROJECT_ID}`;
export const GRAPHCOOL_FILE_API = `https://api.graph.cool/file/v1/${PROJECT_ID}`;
export const GRAPHCOOL_SUBSCRIPTIONS_API = `wss://subscriptions.graph.cool/v1/${PROJECT_ID}`;



// WEBPACK FOOTER //
// ./src/Utils/API.ts